export default __webpack_public_path__ + "static/media/cases1@2x.b158d4d0.webp";